let navisDeliveryPriceDelete = (
    id,
    successAction = (response) => {
        location.reload();
    },
    failAction = (jqXHR) => {
        window.alert(
            "Ошибка при попытке выполнить действие\n" +
            "Статус: " + jqXHR['statusText'] + "\n" +
            "Код статуса: " + jqXHR['status'] + "\n" +
            "Ответ сервера: " + jqXHR['responseText']
        );
    }
) => {
    $.ajax({
        method: 'DELETE',
        cache: false,
        url: "/navis-logistic/delivery-price-delete?id=" + id,
        data: {}
    })
        .done(function (response) {
            successAction(response);
        })
        .fail(function (jqXHR) {
            failAction(jqXHR);
        });
};
